import { useEffect } from "react";
import { useFormikContext } from "formik";

export function ScrollToFormError() {
  const formik = useFormikContext();
  const submitting = formik?.isSubmitting;

  // This will need an update if new form components come into use
  useEffect(() => {
    const errorLabel = document.querySelector(".FormFieldError-text");

    (errorLabel?.parentElement ?? errorLabel)?.scrollIntoView();
  }, [submitting]);

  return null;
}
